import { IPolygonData } from "@/entities";
import { ILocation } from "@/entities/user/address";
import getEndpoint from "@/utils/domain";
import { IPolygonRepository } from ".";
import axios from "axios";
import { createHeader } from "@/utils/createHeader";

// export const ENDPOINT_PATH = getEndpoint("/api/polygon/getPolygonCost");
export const ENDPOINT_PATH = "https://4x2xz1tybj.execute-api.ap-southeast-1.amazonaws.com/Prod";

export class PolygonAPIRepository implements IPolygonRepository {
    async getDeliveryCost(
        location: ILocation,
        apikey: string
    ): Promise<IPolygonData[]> {
        const response = await axios.get(
            `${ENDPOINT_PATH}/getPolygonCost?lat=${location.lat}&lon=${location.lng}`,
            {
                headers: createHeader({ apikey, idToken: null }) as any,
                validateStatus: function (status) {
                    return true;
                },
            }
        );

        if (response.status == 200) {
            const data = response.data["top5"];
            return data;
        } else {
            throw new Error("Failed to get polygon");
        }
    }
}
